import { Injectable } from '@angular/core';
import { Observable, from, of } from 'rxjs';
import { catchError, concatMap, tap } from 'rxjs/operators';
import {
  AddMfaBackup,
  ContinueAuthentication,
  InitiateAuthentication,
  InitiateSsoSession,
  InitiateUserRegistration,
  LoginOAuthParams,
  SubmitEmailOtp
} from '../../../models';
import { NewUserMfaWrapperHelperSupportService } from './new-user-mfa-wrapper-helper-support.service';

@Injectable({
  providedIn: 'root'
})
export class NewUserMfaWrapperHelperService extends NewUserMfaWrapperHelperSupportService {
  initiateMfaWithEmailValidation(
    loginOAuthParams: LoginOAuthParams
  ): Observable<string | InitiateAuthentication> {
    return this.initiateSsoSession
      .initiateSsoSession(loginOAuthParams, 'NEW_USER_WITH_VALIDATION')
      .pipe(
        concatMap((response: InitiateSsoSession) => {
          return this.initiateAuthentication.initiateAuthentication(
            loginOAuthParams.oauthConfig,
            response?.id ? response.id : ''
          );
        }),
        catchError((error) => of(this.mfaUtils.getMfaRegistrationError(error)))
      );
  }

  verifyMfaEmail(
    loginOAuthParams: LoginOAuthParams,
    flowId: string,
    otp: string
  ): Observable<string | AddMfaBackup> {
    return this.submitEmailOtp
      .submitEmailOtp(loginOAuthParams.oauthConfig, flowId, otp)
      .pipe(
        concatMap((response: SubmitEmailOtp) => {
          return this.continueAuthentication.continueAuthentication(
            loginOAuthParams.oauthConfig,
            response?.id ? response.id : ''
          );
        }),
        concatMap((response: ContinueAuthentication) => {
          return this.initiateAuthentication.initiateAuthentication(
            loginOAuthParams.oauthConfig,
            response?.id ? response.id : ''
          );
        }),
        concatMap((response: InitiateAuthentication) => {
          return this.addBackupMfa.addBackupMfa(
            loginOAuthParams.oauthConfig,
            response?.id ? response.id : ''
          );
        }),
        tap((res: AddMfaBackup) => {
          this.applicationName =
            res.devicePairingMethods?.find(
              (device) =>
                device.deviceType === 'MOBILE' &&
                device.applicationName ===
                  loginOAuthParams.oauthConfig.FLY_DELTA_POLLING_APP_NAME
            )?.applicationName ?? '';
          this.applicationId =
            res.devicePairingMethods?.find(
              (device) =>
                device.deviceType === 'MOBILE' &&
                device.applicationName ===
                  loginOAuthParams.oauthConfig.FLY_DELTA_POLLING_APP_NAME
            )?.applicationId ?? '';
        }),
        catchError((error) => of(this.mfaUtils.getMfaRegistrationError(error)))
      );
  }

  initiateUserRegistrationMfaWithEmail(
    loginOAuthParams: LoginOAuthParams,
    verifyEmailMfa: boolean
  ): Observable<string | InitiateUserRegistration> {
    if (verifyEmailMfa) {
      return this.initiateSsoSession
        .initiateSsoSession(
          loginOAuthParams,
          verifyEmailMfa
            ? 'NEW_USER_WITH_VALIDATION'
            : 'NEW_USER_WITHOUT_VALIDATION'
        )
        .pipe(
          concatMap((response: InitiateSsoSession) => {
            if (response && response.id) {
              this.flowId = response.id;
              this.multiFactorAuthenticationUtils.flowId = this.flowId;
            }
            return this.initiateUserRegistration.initiateUserRegistration(
              loginOAuthParams.oauthConfig,
              response?.id ? response.id : ''
            );
          }),
          catchError((error) =>
            of(this.mfaUtils.getMfaRegistrationError(error))
          )
        );
    } else {
      return this.initiateSsoSession
        .initiateSsoSession(loginOAuthParams, 'NEW_USER_WITHOUT_VALIDATION')
        .pipe(
          concatMap((response: InitiateSsoSession) => {
            if (response && response.id) {
              this.flowId = response.id;
              this.multiFactorAuthenticationUtils.flowId = this.flowId;
            }
            return from(
              this.postWithFingerPrintService.postWithFingerPrint(
                loginOAuthParams.oauthConfig,
                response.id ? response.id : ''
              )
            );
          }),
          concatMap((response) => {
            return this.initiateUserRegistration.initiateUserRegistration(
              loginOAuthParams.oauthConfig,
              response.id ? response.id : ''
            );
          }),
          catchError((error) =>
            of(this.mfaUtils.getMfaRegistrationError(error))
          )
        );
    }
  }
}
